<template>
  <div class="main-content sn-content">
    <el-form v-if="user.status == '2' || showEditDiv" ref="form" :model="form" label-width="90px" :rules="rules">
      <div v-if=" showStatus && form.status == '1'" class="vertical" style="color: orange;text-align: left;margin-bottom: 10px">
        <i  class="el-icon-warning-outline" ></i><span>审核中</span>
      </div>
      <div v-if=" showStatus && form.status == '9'" class="vertical" style="color: #F56C6C;text-align: left;margin-bottom: 10px">
        <i  class="el-icon-warning-outline" ></i><span>被驳回，请重新提交</span>
      </div>

      <el-card class="box-card">
        <el-form-item label="认证类别">
          <el-radio class="fl" v-model="form.certType" :label=1>营业执照</el-radio>
          <el-radio class="fl" v-model="form.certType" disabled  :label=0>身份证</el-radio>

        </el-form-item>
        <el-form-item label="名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入公司名称"></el-input>
        </el-form-item>
        <el-form-item label="证件编号" prop="certNo">
          <el-input v-model="form.certNo" :placeholder="form.certType == 1 ? '请输入企业信用机构代码':'请输入个人身份证号'"></el-input>
        </el-form-item>

        <el-form-item :label="form.certType == 1 ? '营业执照': '身份证正面'" prop="certFile1">
          <uploadComponent :actionUrl="actionUrl" :certType="form.certType" @getUrl="getUrl"
                           :picUrl="form.certFile1"></uploadComponent>
        </el-form-item>

        <el-form-item v-if="form.certType == 0" label="身份证反面">

          <uploadComponent :actionUrl="actionUrl" :certType="form.certType" @getUrl="getUrl"
                           :picUrl="form.certFile2"></uploadComponent>
        </el-form-item>
        <el-form-item>
          <el-button v-if="operation == 'add'" v-loading="loading" :disabled="loading" type="primary" class="pxy-primary fl" plain @click="addCertification()">
            提交
          </el-button>
          <el-button v-if="operation == 'edit'" v-loading="loading" :disabled="loading" type="primary" class="pxy-primary fl" plain
                     @click="updateCertification()">更新
          </el-button>
        </el-form-item>

      </el-card>

    </el-form>

    <el-card v-else-if="user.status == '0' && !showEditDiv" class="box-card cert">
        <img :src="$baseUrl+'img/cert.png'" width="132" height="132">
      <div class="company-info">
        <div class="">
          <div class="title">恭喜！您已完成平行云企业实名认证</div>
          <div class="detail">
            <div>认证类型：<span v-if="form.certType == 0">个人</span> <span v-if="form.certType == 1">企业</span></div>
            <div>企业名称：<span>{{form.name}}</span></div>
            <div>证件号码：<span>{{form.certNo}}</span></div>
            <div>认证时间：<span>{{form.updateDate | formatDateTime}}</span></div>
          </div>
          <div class="change">
              <div class="change-authc"><a class="entry" @click="form.status = '1';showStatus=false;showEditDiv= true">更换企业认证</a>
                <div>实名认证变更，需要核实原有实名认证的身份，并完成变更后的实名认证。</div>
            </div>
          </div>
        </div>
      </div>
    </el-card>


  </div>
</template>

<script>
  import {Message} from "element-ui";
  import uploadComponent from '@/components/upload/upload'

  export default {
    components: {uploadComponent},
    data() {
      return {
        loading: false,
        operation: 'add',
        showStatus: true,
        showEditDiv: false,
        form: {
          certType: 1,
          name: '',
          certNo: '',
          status: '' ,
          certFile1: '',
          certFile2: ''
        },
        actionUrl: this.$apiUrl + "/util/upload/picFile",
        rules: {
          name: [{required: true, message: '请输入公司名称', trigger: 'blur'},
            {max: 50, message: '内容超长', trigger: 'blur'}],
          certNo: [{required: true, message: '请输入企业信用机构代码', trigger: 'blur'},
            {max: 50, message: '内容超长', trigger: 'blur'}],
          certFile1: [{required: true, message: '请上传证件', trigger: 'change'},
            {max: 200, message: '内容超长', trigger: 'blur'}],
        }
      }
    },
    created() {

    },
    methods: {
      addCertification: function () {
        var params = {};
        params.certType = this.form.certType;
        params.name = this.form.name;
        params.certNo = this.form.certNo;
        params.certFile1 = this.form.certFile1;
        this.$refs['form'].validate((valid) => {
          if (valid) {
            this.loading = true;
            this.postRequestJson('/uacCert/add', JSON.stringify(params)).then(resp => {
              this.loading = false;
              if (resp && resp.status == 200) {
                var data = resp.data;
                if (data.code == 1000) {
                  //获取到回写的用户信息，更新本地存储的用户信息
                  let user = this.$store.state.user;
                  user.status = "2"; //用户状态为审核中
                  this.form.status = "1";  //form状态为审核中
                  this.$store.commit('login', user)
                  this.getAuthInfo()
                  Message.info(data.message);
                } else {
                  Message.error(data.message);
                }

              }
            });
          }
        })
      },

      updateCertification: function () {
        var params = {};
        params.id = this.form.id;
        params.certType = this.form.certType;
        params.name = this.form.name;
        params.certNo = this.form.certNo;
        params.certFile1 = this.form.certFile1;
        this.$refs['form'].validate((valid) => {
          if (valid) {
            this.loading = true;
            this.postRequestJson('/uacCert/update', JSON.stringify(params)).then(resp => {
              this.loading = false;
              if (resp && resp.status == 200) {
                var data = resp.data;
                if (data.code == 1000) {
                  //获取到回写的用户信息，更新本地存储的用户信息
                  this.getAuthInfo()
                  let user = this.$store.state.user;
                  user.status = "2"; //用户状态为审核中
                  this.form.status = "1";  //form状态为审核中
                  this.$store.commit('login', user)
                  Message.info(data.message);
                } else {
                  Message.error(data.message);
                }

              }
            });
          }
        })
      },

      getAuthInfo: function () {
        this.getRequest('/uacCert/getByUserId').then(resp => {
          if (resp.status == 200) {
            if (resp.data.code == 1000) {
              if(resp.data.result){
                this.operation = 'edit';
                this.form = resp.data.result;
              }else {
                this.operation = 'add';
              }

            } else {
              Message.error(resp.data.message);
            }
          }
        })
      },
      getUrl: function (data) {
        this.form.certFile1 = data;
      },
    },
    mounted: function () {
      if (this.$store.state.user && this.$store.state.user.role == 2 ) {
        this.getAuthInfo()
      }

    },
    computed: {
      user() {
        return this.$store.state.user;
      },
    },
    beforeDestroy() {

    }
  }
</script>
